import {Component, ChangeDetectionStrategy} from '@angular/core';
import {AppRoles, PermissionKeys} from '../app.constants';

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UsersComponent {
    AppRoles = AppRoles;
    PermissionKeys = PermissionKeys;
}
